import { gql } from '@apollo/client';

export const JOB_BASIC_DATA = `
  id
`;

export const PROJECT_JOB = `
  id
  updatedAt
  meetingAt
  completedAt
  ratingOnExpert
  reviewOnExpert
  overall_status
  offerRate
  qualtricsResponse {
    responseId
  }
  qualificationResponses {
    question
  }
  user {
    id
    email
  }
  project {
    id
    title
    requiresProfessionalRegistration
  }
  expert {
    id
    title
    fullName
    organization {
      name
    }
    country
    professionalRegistrations {
      type
      number
    }
    profile_picture
    credits
    stripeAccount {
      stripeId
      isConnected
    }
  }
  bonuses {
    id
    credits
  }
`;

const JOB = gql`
  query Job($id: String!) {
    job(id: $id) {
      ${JOB_BASIC_DATA}
    }
  }
`;

export const JOB_QUALIFICATION_RESPONSES = gql`
  query JobQualificationResponses($id: String!) {
    job(id: $id) {
      id
      project {
        requiresProfessionalRegistration
      }
      expert {
        country
        professionalRegistrations {
          type
          number
        }
      }
      qualificationResponses {
        question
        response
      }
    }
  }
`;

export const JOB_BONUSES = gql`
  query JobBonuses($id: String!) {
    job(id: $id) {
      id
      bonuses {
        id
        credits
        description
        createdAt
      }
    }
  }
`;

export const JOBS_PAGE = gql`
  query JobsPage($filters: JobFilters, $pagination: Pagination, $sortBy: JobSortBy) {
    jobs(filters: $filters, pagination: $pagination, sortBy: $sortBy) {
      ${PROJECT_JOB}
    }
  }
`;

export const JOB_MEETING_CONTEXT = gql`
  query JobMeetingContext($id: String!) {
    job(id: $id) {
      id
      zoomMeeting {
        meetingLink
      }
      interviewers {
        id
        email
        fullName
      }
      project {
        id
        team {
          id
        }
      }
    }
  }
`;

export const SURVEY_RESPONSES = gql`
  query Job($id: String!) {
    job(id: $id) {
      id
      qualtricsResponse {
        responses {
          questionId
        }
      }
    }
  }
`;

export const UPDATE_JOB = gql`
  mutation UpdateJob($userId: ID!, $projectId: ID!, $job: JobInput!) {
    updateJob(userId: $userId, projectId: $projectId, job: $job) {
      ${PROJECT_JOB}
    }
  }
`;

export const INVITE_EXPERT_TO_PROJECT = gql`
  mutation InviteExpertToProject($userId: ID!, $projectId: ID!) {
    inviteExpertToProject(userId: $userId, projectId: $projectId) {
      id
      project {
        id
        numPendingInvites
        jobs {
          id
          overall_status
          user {
            id
          }
        }
        team {
          id
          availableInvites
        }
      }
    }
  }
`;

export const SEARCH_JOBS = gql`
  query SearchProjectData($projectId: ID!, $query: String!, $exclusions: [String]) {
    searchProjectData(projectId: $projectId, query: $query, exclusions: $exclusions) {
      total
      facets {
        items {
          value
        }
      }
      items {
        highlights {
          field
          segments
        }
        item {
          __typename
          ... on Job {
            ${PROJECT_JOB}
          }
        }
      }
    }
  }
`;

export default JOB;
